import type { FaireProductEntity } from "../../entity_types/product";

export const p_szfa9eng6w: FaireProductEntity = {
  token: "p_szfa9eng6w",
  type: "product",
  name: "Beam Colostrum - Unflavored (30 servings) Jar",
  brandToken: "b_j8frta4jec",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b5f1292ac0b74884948fea410f310ff74459d40f26d95399500693fc7b323180.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa8d81c0759d982be717d8d7a535ed1e0e7b91db135706a0d71cfa0c708d5dd3.jpeg",
    "https://cdn.faire.com/fastly/772426e8f3e9e51a21ed0cad0662add3ea9325f0f82f0a94f960811e94b35aef.jpeg",
    "https://cdn.faire.com/fastly/63de6dc909db287643840a265aced6d1cc2c021c910d82485b5f66f3f27249df.jpeg",
    "https://cdn.faire.com/fastly/7f749a56532c5a92c6b27dda5f70150a28a083d90b249698ccbfb846d0b783e4.jpeg",
    "https://cdn.faire.com/fastly/36c57c1bdd099ffba7664b9c80294ddfb8c934c5522ba401e31d9bcab7910024.jpeg",
  ],
  priceDollars: 24.25,
  description:
    "Colostrum is bovine sourced and often nicknamed “liquid gold” due to its high level of nutrients, antibodies, and antioxidants. With immunoglobulins, growth factors, and vitamins, separate studies have shown colostrum to improve exercise performance and reduce sick days.*\n\nKey Benefits (bullet points):\n- Supports immune system function\n- Promotes gut health & gut lining integrity\n- Rich in antibodies & bioactive compounds\n- Daily wellness support for all ages\n\nWhat Makes It Different:\n- High-potency bovine colostrum (20% IgG) for strong immunity support\n- Easy-to-mix powder, neutral flavor, perfect for smoothies or beverages\n- 0g added sugar, no fillers\n- Third party tested \n\nHow to use: Mix into 8oz of preferred liquid and consume any point of the day. \n\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease*\n",
  tags: [],
  msrpDollars: 48.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:32.210Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
